export default __webpack_public_path__ + "static/media/README.b03fbda0.md";